document.addEventListener("DOMContentLoaded", () => {

  let activeLayer = null;
  let offsetX = 0;
  let offsetY = 0;
  let resizeLayer = null;
let startWidth = 0;
let startX = 0;

  document.addEventListener(
"pointerdown",
(e)=>{

  const resizeHandle = e.target.closest(
    ".text-resize-handle, .image-resize-handle, .resize-handle"
  );

  const layer = e.target.closest(
    ".embroidery-text-layer, .embroidery-image-layer"
  );

  // ONLY prevent default when interacting with embroidery layers
  if (resizeHandle || layer) {
    e.preventDefault();
  }

  if (resizeHandle) {

    resizeLayer =
      resizeHandle.closest(
        ".embroidery-image-layer"
      );

    if (!resizeLayer) return;

    startWidth =
      resizeLayer.offsetWidth;

    startX =
      e.clientX;

    return;
  }

  if (!layer) return;

  document
    .querySelectorAll(
      ".embroidery-text-layer, .embroidery-image-layer"
    )
    .forEach(el =>
      el.classList.remove("active-layer")
    );

  layer.classList.add(
    "active-layer"
  );

  window.selectedEmbroideryLayer =
    layer;

  activeLayer = layer;

  activeLayer.style.touchAction =
    "none";

  const rect =
    layer.getBoundingClientRect();

  offsetX =
    e.clientX - rect.left;

  offsetY =
    e.clientY - rect.top;

});

  document.addEventListener(
  "pointermove",
  (e) => {

    if (resizeLayer) {

      let newWidth =
        startWidth +
        (e.clientX - startX);

      if (newWidth < 50)
        newWidth = 50;

      resizeLayer.style.width =
        newWidth + "px";

      document.dispatchEvent(
        new Event(
          "embroideryUpdated"
        )
      );

      return;
    }

    if (!activeLayer) return;

    const canvas =
      document.getElementById(
        "embroideryCanvas"
      );

    const canvasRect =
      canvas.getBoundingClientRect();

    let left =
      e.clientX -
      canvasRect.left -
      offsetX;

    let top =
      e.clientY -
      canvasRect.top -
      offsetY;

    if (left < 0) left = 0;
    if (top < 0) top = 0;

    activeLayer.style.left =
      left + "px";

    activeLayer.style.top =
      top + "px";

  }
);

  document.addEventListener(
  "pointerup",
  () => {

    if (activeLayer) {
      window.EMBStorage?.save();
    }

    if (resizeLayer) {

  window.EMBStorage?.save();

}

resizeLayer = null;
activeLayer = null;

  }
);

});